<template>
  <div class="home">
    <app-slideshow></app-slideshow>
  </div>
</template>

<script>

import Gallery from '@/components/Gallery'

export default {
  name: 'home',
  components: {
    'app-slideshow': Gallery,
  }
}
</script>
